import React, { useMemo } from 'react';
import AlertCard, { AlertCardProps } from '../alert-card/alert-card.component';
import styles from './article-list-container.component.module.less';
import useToggleState from 'src/hooks/use-toggle-state';
import ArticleCard, {
  ArticleCardProps,
} from '../article-card/article-card.component';
import {
  IconNavigationChevronDownComponent,
  IconNavigationChevronUpComponent,
} from '@vaad1st/component.atom.icons';
import {
  ButtonComponent,
  ButtonColour,
  ButtonType,
  IconPosition,
} from '@vaad1st/component.atom.button';
import classNames from 'classnames';
import ContainerComponent from '../container/container.component';

interface ArticleCardContainerProps {
  articleItems: ArticleCardProps[] | AlertCardProps[];
  fallbackText?: string;
  componentId: string;
  displayAs: 'notification' | 'default';
}

const ArticleListContainer: React.FC<ArticleCardContainerProps> = (
  props: ArticleCardContainerProps
) => {
  const [isSeeAll, setIsSeeAll] = useToggleState(false);
  const {
    articleItems = [],
    displayAs = 'notification',
    fallbackText,
    componentId,
  } = props;

  const Card = useMemo(
    () => (displayAs === 'notification' ? AlertCard : ArticleCard),
    [displayAs]
  );

  const rows = [];

  for (let i = 0; i < articleItems.length; i += 4) {
    rows.push(
      <div
        className={classNames(
          styles['article-list__row'],
          styles[`article-list__row--${articleItems.slice(i, i + 4).length}`]
        )}
        key={i}
      >
        {articleItems.slice(i, i + 4).map((card: any, index) => (
          <div
            data-testid={'article-card'}
            className={classNames(
              styles[`item${index + 1}`],
              styles[`item${index + 1}`],
              styles['article-card-container__grid-item']
            )}
            key={index}
          >
            <Card {...card} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <section
      id={componentId}
      data-testid={`articleslist${componentId ? `-${componentId}` : ''}`}
      className={classNames(
        styles['article-card-container'],
        displayAs === 'notification'
          ? styles['article-card-container__list']
          : styles['article-card-container__grid']
      )}
    >
      <ContainerComponent>
        {articleItems.length === 0 && fallbackText ? (
          <p>{fallbackText}</p>
        ) : (
          <>
            <div
              className={classNames(
                styles['article-card-items'],
                displayAs === 'notification'
                  ? styles['article-card-items__list']
                  : styles['article-card-items__grid']
              )}
            >
              {isSeeAll ? rows : rows.slice(0, 1)}
            </div>
            {rows.length > 1 ? (
              <div className={styles['article-card-container__cta']}>
                <ButtonComponent
                  type={ButtonType.Link}
                  onClick={setIsSeeAll}
                  aria-expanded={isSeeAll}
                  aria-controls="article-card-list"
                  colour={ButtonColour.Contrast}
                  iconPosition={IconPosition.Right}
                  iconChild={
                    isSeeAll ? (
                      <IconNavigationChevronUpComponent />
                    ) : (
                      <IconNavigationChevronDownComponent />
                    )
                  }
                >
                  {`See ${isSeeAll ? 'fewer' : 'all'} `}
                </ButtonComponent>
              </div>
            ) : null}
          </>
        )}
      </ContainerComponent>
    </section>
  );
};

export default ArticleListContainer;
